import axios from 'axios';
import {backendHost} from '../../../../store/config';

const postUpdateJackpot = (params) => {
    return axios.post(`${backendHost}/api/admin/jackpot/update`, params);
};

export {
    postUpdateJackpot
}